import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { $post } from './store/api';

function Login({ onLogin, onForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await $post('auth/login', { Email: email, Jelszo: password });
      onLogin(res.data.token, res.data.Nev);
    } catch (err) {
      setError(err.response?.data?.error || 'Bejelentkezési hiba.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="auth-logo">
          <img
            src="https://www.presentperfect.xyz/wp-content/uploads/2018/11/pp_logo_head_mobile.png"
            alt="Present Perfect"
          />
        </div>
        <h2 className="auth-title">Bejelentkezés</h2>
        {error && <Alert variant="danger" className="py-2 px-3" style={{ fontSize: 14 }}>{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>E-mail cím</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="pelda@email.com"
              required
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Jelszó</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Jelszó"
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit" className="w-100" disabled={loading}>
            {loading ? 'Betöltés…' : 'Bejelentkezés'}
          </Button>
        </Form>
        <div className="auth-footer">
          <button className="auth-link" onClick={onForgot}>Elfelejtett jelszó?</button>
        </div>
      </div>
    </div>
  );
}

export default Login;
